<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import upprocess from '../../../../common/upProcess/index.vue'
	import uploadFile from '../../../../common/uploadFile/index.vue'
	import updateywkm from '../../../../common/updateywkm/index.vue'
	import config from '../../../../../../configHttp.js'
	import {
		iinv_importIinvExcel,
	} from '../../../../../api/iinv.js'
  import {importTaxOfficeTemplate} from '../../../../../api/sjmb.js'
	export default {
		name: 'upresult',
		components: {
			upprocess,
			uploadFile,
			updateywkm
		},
		data: function() {
			return {
				upformdata: {}, //文件信息
				importType: "0", //模板类型
				mboptions: getdata().mboptions,
				uptype: 1,
				batchNum: "",
				timer:null,
				count: 5,
				successCount:0,
				successdata:{},
			};
		},
		created() {},
		
		methods: {
			// 上传
			getuploadparams(e) { //获取上传文件流
				this.upformdata = e
			},
      fordownloadmb() { //模板下载
        let fileName;
        let url;
        if (this.importType === "2") {
          fileName = "税局导入模板";
          url = "dataAcquisition/template/download";
        } else {
          fileName = "进项增值税明细表导入模板";
          url = "iinv/template/download";
        }
        let params = {
          downUrl: config.baseURL + url,
          typeObj: {
            toForm: false,
            fileName: fileName,
            fileType: 'xlsx',
          },
        }
        this.$downloadcommon(params)
      },
      importIinvExcel() {
        if (this.$emptyandnull(this.upformdata.upfile)) {
          this.$message.error("请选择要上传的文件")
          return false
        }
        let formData = {
          importType: this.importType,
          file: this.upformdata.upfile
        };
        if (this.importType === "2") {
          importTaxOfficeTemplate(formData).then(res => {
            if (!res.data.data.IINV) {
              this.$message.error("当前导入文件没有进项发票数据");
              return false;
            }
            this.importResultHandle(res.data.code, res.data.data.IINV.batchNo, res.data.data.IINV, res.data.msg);
          })
        } else {
          iinv_importIinvExcel(formData).then(res => {
            this.importResultHandle(res.data.code, res.data.data.batchNo, res.data.data, res.data.msg);
          })
        }
      },
      importResultHandle(code, batchNum, successdata, errMsg) {
        if (code == 1) {
          this.uptype = 3
          this.batchNum = batchNum
          this.successdata = successdata
          let self = this;
          if (self && !self._isDestroyed) {
            this.timer = setInterval(() => {
              this.count--
              if (self._isDestroyed) {
                clearInterval(this.timer);
                return false
              }
              if (this.count == 0) {
                this.$refs['uploadfileRef'].forrefresh()
                this.uptype = 1
                clearInterval(this.timer);
              }
            }, 1000)
          }
          this.uptype = 3
          this.count = 5
        } else {
          this.$message.error(errMsg)
        }
      },
			forbackup(){
				this.$refs['uploadfileRef'].forrefresh()
				this.uptype=1
				clearInterval(this.timer);
			},
			forchooseindex(index){
					this.$emit("forchooseindex",index)
			},
						//跳转至自定义模板
			toCustomTemplate () {
				this.$router.push("/CustomTemplate")
			}
		}


	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
